module.exports = __webpack_public_path__ + "static/media/Multicolore.5c5da173.otf";